<template>
  <div class="iframe-view">
    <div class="iframe-header">
      <el-button type="text" icon="el-icon-arrow-left" class="back-btn" @click="goBack">返回</el-button>
      <span class="header-title">查看分析</span>
    </div>
    <div class="iframe-content">
      <iframe
        v-if="targetUrl"
        :src="targetUrl"
        frameborder="0"
        class="content-iframe"
        allowfullscreen
      ></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IframeView',
  data() {
    return {
      targetUrl: ''
    }
  },
  created() {
    const url = this.$route.query.url;
    if (url) {
      this.targetUrl = decodeURIComponent(url);
    }
  },
  methods: {
    goBack() {
      // this.$router.push('/');
      this.$router.push({
        name: 'Home',
        query: { tab: 6 }
      });
    }
  }
}
</script>

<style scoped>
.iframe-view {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: #fff;
}
.iframe-header {
  position: relative;
  height: 44px;
  line-height: 44px;
  background: #f5f5f5;
  border-bottom: 1px solid #ddd;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.back-btn {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
}
.header-title {
  font-size: 16px;
  color: #333;
  font-weight: 500;
}
.iframe-content {
  flex: 1;
  overflow: hidden;
}
.content-iframe {
  width: 100%;
  height: 100%;
  border: none;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/IframeView.vue